import React from 'react'
import TranslationCont from '../../General/TranslationCont'

const SkipToMainAccess = () => (
    <a className="access-skip" href="#maincontent">
        <TranslationCont id="skip_to_main_content">Skip to main content</TranslationCont>
    </a>
)

export default SkipToMainAccess